// extracted by mini-css-extract-plugin
export default {"noDataComponent":"no-data-component__no-data-component__XCdqS"};